<template>
  <div class="zcl-player">
    <div class="zcl-player-inner w100 h100" :id="currId" :key="currId"></div>
  </div>
</template>

<script>
  export default {
    name: "ZclPlayer",
    computed: {
      isZcl() {
        return true;
      },
      scriptLink() {
        return `${this.origin}/${this.version}/${this.path}/${this.api}.js`;
      },
      cssLink() {
        return `${this.origin}/${this.version}/${this.path}/${this.api}.css`;
      },
      currId() {
        return 'zcl-player-' + this.content_id + '-' + this.datafile_id + '-' + this.sku_id;
      },
      apiLink() {
        return `${this.origin}/${this.version}/readerApi.js`;
      },
      innerClassName() {
        return this.className || this.api.replace(/^web/, '').replace(/^[a-z]/i, s => s.toLocaleUpperCase());
      },
      currentTime: {
        get() {
          return this.curr;
        },
        set(val) {
          this.emitPlayer('seek', val);
          this.curr = val;
        },
      },
      playbackRate: {
        get() {
          return this.volume;
        },
        set(val) {
          this.emitPlayer('setVolume', val);
          this.volume = val;
        },
      },
    },
    props: {
      version: {
        type: String,
        default: 'v1.3.0-20210624-r',
      },
      path: {
        type: String,
        default: 'mobilePlayer',
      },
      api: {
        type: String,
        default: 'mobileAudioPlayer',
      },
      app_id: {
        type: String,
        // default: process.env.NODE_ENV === 'production' ? '910455644417417216' : '897157611583963136',
        default: '910455644417417216',
      },
      app_sec: {
        type: String,
        // default: 'wkzq!jR^^2KzSjx$',
        default: process.env.NODE_ENV !== 'production' ? 'wkzq!jR^^2KzSjx$' : 'Y(^H(w^E&!eEV)O8',
      },
      host: {
        type: String,
        // default: process.env.NODE_ENV === 'production' ? 'https://gateway.keledgechain.com/keledgechain' : 'https://dev.keledge.com:40550',
        default: 'https://gateway.keledgechain.com/keledgechain'
      },
      className: {
        type: String,
        default: '',
      },
      content_id: {
        type: String,
        default: '',
      },
      datafile_id: {
        type: String,
        default: '',
      },
      sku_id: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        origin: 'https://cdn.keledge.com/sdk/web',
        player: null,
        apiObj: null,
        playerIsInit: false,
        curr: 0,
        volume: 1,

        isPlaying: false,
        timer: null,
        checkEnd: null,
      };
    },
    watch: {
      currId() {
        this.initPlayer();
      },
      scriptLink() {
        this.initResource();
      },
      player() {
        if (!this.playerIsInit) {
          this.initPlayerEvent();
        }
        this.$emit('player-change', this.player);
      },
    },
    created() {
    },
    mounted() {
      this.initResource();
    },
    methods: {

      // 开始监听player播放器事件
      initPlayerEvent() {
        if (this.player) {
          // 所有可能 的事件
          // 渲染完成的事件
          const eventList = {
            load: [
              'AUDIO_BASE_PLAYER_INIT_COMPLETE',
              'VIDEO_BASE_PLAYER_INIT_COMPLETE',
              'MOBILE_AUDIO_BASE_PLAYER_INIT_COMPLETE',
              'MOBILE_VIDEO_BASE_PLAYER_INIT_COMPLETE',
              'RENDER_PDF_PAGE_COMPLETE',
              'RENDER_EPUB_CHAPTER_COMPLET',
              'MOBILE_RENDER_PDF_PAGE_COMPLETE',
              'MOBILE_RENDER_EPUB_CHAPTER_COMPLETE',
            ],
            // 播放进度更新的事件
            update: [
              'AUDIO_TIME_UPDATE',
              'VIDEO_TIME_UPDATE',
              'MOBILE_AUDIO_TIME_UPDATE',
              'MOBILE_VIDEO_TIME_UPDATE',
              'PDF_CHANGE_PAGE',
              'PDF_CHANGE_PROCESS',
              'EPUB_CHANGE_PROCESS',
              'MOBILE_PDF_NEXT_PAGE',
              'MOBILE_PDF_PREV_PAGE',
              'MOBILE_EPUB_NEXT_PAGE',
              'MOBILE_EPUB_PREV_PAGE',
            ],
            // 播放结束的事件
            stop: [
              'AUDIO_PLAY_END',
              'VIDEO_PLAY_END',
              'MOBILE_AUDIO_PLAY_END',
              'MOBILE_VIDEO_PLAY_END',
              'MOBILE_READ_END',
            ],
            // 阅读结束的事件
            end: [
              'READ_END',
            ],
          };
          Object.keys(eventList).forEach(event => {
            eventList[event].forEach(targetEvent => {
              this.player.on(targetEvent, params => {
                if (event === 'update') {
                  this.timeUpdate(params);
                } else if (event === 'stop') {
                  clearTimeout(this.checkEnd);
                  this.checkEnd = setTimeout(() => {
                    this.$emit(event, params, targetEvent);
                  }, 300);
                  return;
                }
                this.$emit(event, params, targetEvent);
              });
            });
          });
          this.playerIsInit = true;
        }
      },
      // 触发player的事件
      emitPlayer(event, ...params) {
        this.player && typeof this.player[event] === 'function' && this.player[event](...params);
      },

      play() {
        this.emitPlayer('play');
      },
      pause() {
        this.emitPlayer('pause');
      },

      // 时间更新
      timeUpdate(time) {
        this.curr = time;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.isPlaying = false;
          this.$emit('pause');
        }, 1000);
        if (this.isPlaying === false) {
          this.isPlaying = true;
          this.$emit('play');
        }
      },

      initResource(type = 'apiLink') {
        let id = 'zcl-' + type + this.api;
        let dom = document.getElementById(id);
        let succ = !!dom;
        dom = document.createElement('script');
        dom.id = id;
        dom.src = this[type];
        switch (type) {
          case 'apiLink':
            if (!succ) {
              dom.onload = () => this.initResource('scriptLink');
              document.body.appendChild(dom);
            } else {
              this.initResource('scriptLink');
            }
            break;
          case 'scriptLink':
            if (!succ) {
              dom.onload = () => this.initResource('cssLink');
              document.body.appendChild(dom);
            } else {
              this.initResource('cssLink');
            }
            this.initApi();
            break;
          case 'cssLink':
            if (!succ) {
              dom = document.createElement('link');
              dom.id = id;
              dom.href = this[type];
              dom.type = "text/css";
              dom.rel = "stylesheet";
              document.head.appendChild(dom);
            }
            break;
        }
      },
      async initPlayer() {
        if (this.player) {
          this.player.destroy();
        }
        if (!this.sku_id || !this.datafile_id || !this.content_id) {
          return;
        }
        await this.apiObj.initBook(this.sku_id, this.datafile_id, this.content_id);
        this.player = new window[this.innerClassName]({
          viewId: this.currId, //domId
        }, this.apiObj);
      },
      async initApi() {
        this.apiObj = new ReaderApi();
        await this.apiObj.initDevice(this.app_id, this.host);
        this.initPlayer();
        return this.apiObj;
      },
    }
  }
</script>

<style scoped lang="less">
  /deep/ .zcl-player-inner {
    :nth-child(n) {
      display: none !important;
    }
    .web-video-player,
    .video-main {
      display: block !important;
    }
    .video-main,
    .web-video-player {
      width: 100% !important;
      height: 100% !important;
      video {
        display: block !important;
      }
    }
  }
</style>